import cloneDeep from 'clone-deep'
import { Frequency } from 'components/Frequency'
import { validateFrequencyData } from 'components/Frequency/logic'
import { InputType } from 'config'
import { accountTypes } from 'config/user.type.constants'
import { useEffect, useMemo, useState } from 'react'
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { createReminder, getReminderById, updateReminder } from 'services/apis/reminder'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

import { defaultReminderInputs, reminderInitialData } from './constants'

export const ReminderDetailModal = ({
  reminderId,
  onModalOk,
  adminEmails,
  onModalClose,
  loanNumber = 0,
}: {
  reminderId: number
  onModalOk: Function
  adminEmails: string[]
  onModalClose: () => void
  loanNumber: number
}) => {
  const [loanGlobalStatus, loanDetail] = useSelector((state: any) => [state.loanGlobalStatus, state.loanDetail])

  const [isLoading, setIsLoading] = useState(false)
  const [inputs, setInputs] = useState<Record<string, InputType>>(defaultReminderInputs(loanGlobalStatus, reminderId))
  const [data, setData] = useState<Record<string, any>>(reminderInitialData())
  const [errorCheck, setErrorCheck] = useState(false)
  const isCreate = reminderId === -1

  const assignOptions = useMemo(() => {
    const options = { ...accountTypes }
    adminEmails.forEach((email) => (options[email] = email))
    return options
  }, [adminEmails])

  const initData = async () => {
    setIsLoading(true)
    const res = await getReminderById(reminderId)
    setData(res)
    setIsLoading(false)
  }
  useEffect(() => {
    if (!isCreate) initData()
    else if (loanNumber) {
      setData({ ...reminderInitialData(), loanNumber: loanDetail.byteproFileName || loanNumber })
    }
  }, [])

  const onChange = (key: string, value: any) => {
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
  }

  const onOk = async () => {
    let hasError = false
    const newInputs = cloneDeep(inputs)
    Object.keys(inputs).map((key) => {
      newInputs[key].error = InputValidate({ ...newInputs[key], value: data[key] })
      if (newInputs[key].error?.length) hasError = true
      data[key] = newInputs[key].value
    })
    setInputs(newInputs)

    hasError = hasError || validateFrequencyData(data.frequency)
    setErrorCheck(true)
    if (hasError) return

    let newItem
    setIsLoading(true)
    if (isCreate) {
      newItem = await createReminder(data)
      toast('Successfully created a Reminder', { type: 'success' })
    } else {
      newItem = await updateReminder(data.id, data)
      toast('Successfully updated a Reminder', { type: 'success' })
    }
    setIsLoading(false)
    onModalOk(newItem)
  }

  return (
    <Modal
      title={`${isCreate ? 'Add' : 'Edit'} Reminder${!isCreate ? ` - ${data.no}` : ''}`}
      onOk={onOk}
      onClose={onModalClose}
      isOpen
      loading={isLoading}
    >
      <div className="relative w-[500px]">
        {Object.keys(inputs).map((key) => {
          if (key === 'completeAt' && !data['loanNumber']) return
          const input: any = inputs[key]
          input.value = data[key]
          if (key === 'assignedTo') {
            input.options = assignOptions
            input.value = data[key] || []
          }
          if (loanNumber && key === 'loanNumber') input.disabled = true
          return (
            <>
              <div className="mb-2" key={key}>
                <RenderInput input={input} Key={key} key={key} onChange={onChange} />
              </div>
              {key === 'description' && (
                <Frequency
                  data={data.frequency}
                  startDate={data.date}
                  onChange={(value: any) => onChange('frequency', value)}
                  errorCheck={errorCheck}
                />
              )}
            </>
          )
        })}
      </div>
    </Modal>
  )
}
